import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col gap-12px" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "h4" }
const _hoisted_4 = { class: "row gap-30" }
const _hoisted_5 = { class: "toggle-switch-row" }
const _hoisted_6 = {
  key: 0,
  class: "txt-grey-64 mtop-02"
}
const _hoisted_7 = { class: "flex flex-col gap-02" }
const _hoisted_8 = {
  key: 0,
  class: "txt-grey-64"
}

import { Select, ToggleSwitch, useToast } from "primevue";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useAppUserStore } from "@/stores/appUser";
import { useCurrentEntryStore } from "@/stores/currentEntry";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { ApiError } from "@/models/share.model";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { FindNotificationPreferencesRequest, NotificationLanguageIsoCodeEnum, NotificationLanguageResponse, NotificationPreferenceApi, NotificationPreferenceResponse, NotificationPreferenceTypeEnum, UpdateNotificationPreferenceOperationRequest } from "@/apiGenerate/medserver";


export default /*@__PURE__*/_defineComponent({
  __name: 'esNotification',
  props: {
    hasEmails: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const { t } = useI18n();
const toast = useToast();
const currentEntryStore = useCurrentEntryStore();
const appUserStore = useAppUserStore();

const notificationPreferenceApi = new NotificationPreferenceApi(medServerApiConfig);

const preferences = ref<NotificationPreferenceResponse[]>([]);
const languages = Object.values(NotificationLanguageIsoCodeEnum)

const selectedLanguage = ref<NotificationLanguageResponse>()
  
const languagePreference = computed((): NotificationPreferenceResponse | undefined => {
  return preferences.value.find((preference) => preference.type === NotificationPreferenceTypeEnum.Language);
});

const deliveryTypePreferences = computed((): NotificationPreferenceResponse[] => {
  return preferences.value.filter((preference) => preference.type === NotificationPreferenceTypeEnum.DeliveryEmail
    // || preference.type === NotificationPreferenceTypeEnum.DeliverySms
    // || preference.type === NotificationPreferenceTypeEnum.DeliveryInApp
    );
});

const instituteId = computed((): string | undefined =>  {
  if (!appUserStore.currentHealthGroupMembership
    || !appUserStore.currentHealthGroupMembership.instituteWithRole
    || !appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId) 
  {
    return undefined;
  }

  return appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId;
});

const patientId = computed((): string | undefined => {
  return currentEntryStore.modalPatient.personWithRoleId;
});

const isAtLeastOneOptionDisabled = computed(() => deliveryTypePreferences.value.some(deliveryTypePreference => !deliveryTypePreference.value));

const languageOptions = computed(() =>
    languages.map((code) => ({
      code,
      label: t(`enum.languages.${code}`)
    }))
);

const findNotificationPreferences = async (
  instituteId: string,
  patientId: string
) => {
  const findNotificationPreferencesRequest: FindNotificationPreferencesRequest = {
    instituteId: instituteId,
    personId: patientId
  };

  notificationPreferenceApi
    .findNotificationPreferences(findNotificationPreferencesRequest)
    .then((newPersonNotificationPreferences) => {
      preferences.value = newPersonNotificationPreferences

      if (Object.keys(NotificationLanguageIsoCodeEnum).map(isoCode => isoCode.toUpperCase()).includes(languagePreference.value.value.toUpperCase())) {
        selectedLanguage.value = {
          uuid: languagePreference.value.uuid,
          iso: languagePreference.value.value as NotificationLanguageIsoCodeEnum
        };
      }
    })
    .catch((error: ApiError) => {
      toastError(toast, {
        summary: t("common.toast.error"),
        detail: error.status ? t(`error.${error.status}`) : t("error.DEFAULT"),
      });
    });
};

const updateNotificationPreference = async (
  instituteId: string,
  patientId: string,
  notificationPreferenceId: string,
  notificationDeliveryTypeUuid: NotificationPreferenceTypeEnum,
  preferenceValue: string, 
  isActive: boolean
) => {
  const updateNotificationPreferenceRequest: UpdateNotificationPreferenceOperationRequest = {
    instituteId: instituteId,
    notificationPreferenceId: notificationPreferenceId,
    personId: patientId,
    updateNotificationPreferenceRequest: {
      active: isActive,
      value: preferenceValue,
      type: notificationDeliveryTypeUuid
    }
  };

  notificationPreferenceApi
    .updateNotificationPreference(updateNotificationPreferenceRequest)
    .then(async () => {
      toastSuccess(toast, {
        summary: t("common.toast.success.update"),
        detail: t("settings.params.account.toast.update.information"),
      });

      await findNotificationPreferences(instituteId, patientId);
    })
    .catch((error: ApiError) => {
      toastError(toast, {
        summary: t("common.toast.error"),
        detail: error.status ? t(`error.${error.status}`) : t("error.DEFAULT"),
      });
    });
};

__expose({
  reloadPreferences: () => {
    if (instituteId.value && patientId.value) {
      findNotificationPreferences(instituteId.value, patientId.value);
    }
  }
});

onMounted(async () => {
  if (instituteId.value && patientId.value) {
    await findNotificationPreferences(instituteId.value, patientId.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)('patient.admin.subtitle.notificationDetail')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryTypePreferences.value, (deliveryType) => {
        return (_openBlock(), _createElementBlock("div", {
          key: deliveryType.uuid
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_unref(t)(`patient.admin.notification.deliveryType.${deliveryType.type}`)) + " ", 1),
            _createVNode(_unref(ToggleSwitch), {
              disabled: !deliveryType.value,
              "model-value": deliveryType.active,
              "onUpdate:modelValue": ($event: any) => (updateNotificationPreference(instituteId.value, patientId.value, deliveryType.uuid, deliveryType.type, deliveryType.value, $event))
            }, null, 8, ["disabled", "model-value", "onUpdate:modelValue"])
          ]),
          (deliveryType.type === _unref(NotificationPreferenceTypeEnum).DeliveryEmail && !deliveryType.value && props.hasEmails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('patient.admin.notification.noDefaultEmail')), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.admin.notification.preferredLanguage')), 1),
      (selectedLanguage.value)
        ? (_openBlock(), _createBlock(_unref(Select), {
            key: 0,
            "v-model": selectedLanguage.value,
            placeholder: _unref(t)(`enum.languages.${selectedLanguage.value.iso}`),
            options: languageOptions.value,
            "option-label": "label",
            "option-value": "code",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (iso) => updateNotificationPreference(instituteId.value, patientId.value, languagePreference.value.uuid, 'LANGUAGE', iso, true))
          }, null, 8, ["v-model", "placeholder", "options"]))
        : _createCommentVNode("", true)
    ]),
    (isAtLeastOneOptionDisabled.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)("patient.admin.notification.error.missingContactDetails")), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})